import { useSuspenseQuery } from '@tanstack/react-query';
import { Redirect } from 'expo-router';
import React from 'react';

import { shopDetailQuery } from '@/api/shop/shopDetailQuery';
import { useLatchedCategoryFirstDecision } from '@/hooks/flags/useLatchedCategoryFirstDecision';

import type { CategoryFirstGuardProps } from './types';

/**
 * Renders `children` when category-first is on, otherwise replaces the screen
 * with `fallbackHref`.
 */
export function CategoryFirstGuard({
  shopRoute,
  fallbackHref,
  fallback = null,
  children,
}: CategoryFirstGuardProps) {
  const { data: shop } = useSuspenseQuery(shopDetailQuery(shopRoute));
  const isCategoryFirstEnabled = useLatchedCategoryFirstDecision(shop);

  if (isCategoryFirstEnabled === null) {
    return <>{fallback}</>;
  }

  if (!isCategoryFirstEnabled) {
    return <Redirect href={fallbackHref} />;
  }

  return <>{children}</>;
}
